var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"draft-banner",attrs:{"role":"status"}},[_c('DraftBadge'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',[_vm._v("Draft Preview")]),_c('p',[_vm._v("This content is visible only to authorized Reckon users while Draft Mode is on.")])])
}]

export { render, staticRenderFns }